import moment from 'moment';
import * as types from '../../constants/actionsType'

const initialState = {
  timezoneList: [],
  countryList:[],
  getOrganizationList:[],
  isLoading:false,
  isCountryLoading:false,
  isTimezoneLoading:false
}
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TIMEZONE_LIST_LOADING:
      return{
        ...state,
        isTimezoneLoading:action.data
      }
    case types.COUNTRY_LIST_LOADING:
      return{
        ...state,
        isCountryLoading:action.data
      }
    case types.GET_TIMEZONE_LIST:
      return {
        ...state,
        timezoneList: action.data,
      }
    case types.GET_COUNTRY_LIST:
      return{
        ...state,
        countryList:action.data
      }
    case types.ORGANIZATION_LOADING:
      return{
        ...state,
        isLoading:action.data
      }
    case types.GET_ORGANIZATION:
      return{
        ...state,
        getOrganizationList:action.data[0],
      }
    default:
      return state
  }
}
export default reducer
